import api from '../../utils/api';

// Types
import type { MarketingLead, MarketUpdate, Subscription, UnsubscribeParams } from '../../types/Marketing';

// @ts-ignore
import constants from '../../flux/constants';
import { augmentError } from '../../utils/errors';

export const createMarketingLead = ({
  fullAddress = '',
  unit = '',
  email = null,
}: {
  fullAddress?: string;
  unit?: string;
  email?: string | null;
}) => {
  // @ts-ignore
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const query = state.router.location.query;
      const { utm_source = '', utm_medium = '', utm_campaign = '', utm_content = '' } = query;

      if (__DEV__) {
        return;
      }

      const marketingLeadObject: MarketingLead = {
        fullAddress,
        unit,
        marketingLeadType: 'paidInclusionRentEstimator',
        utmSource: utm_source,
        utmMedium: utm_medium,
        utmCampaign: utm_campaign,
        utmContent: utm_content,
      };

      if (email) {
        marketingLeadObject.email = email;
      }

      await dispatch(api.marketing.createMarketingLead(marketingLeadObject));

      return true;
    } catch (error) {
      // @ts-ignore
      const shouldLogAction = !error.data || !error.data.action;
      augmentError(error, {
        ...(shouldLogAction && {
          action: 'Error in MarketingActions#createMarketingLead',
        }),
      });

      throw error;
    }
  };
};

export const createMarketUpdate = (params: MarketUpdate) => {
  // @ts-ignore
  return async (dispatch) => {
    try {
      const requiredParams = {
        email: params.email,
        zpid: params.zpid,
        price: params.price,
        lat: params.lat,
        lon: params.lon,
      };

      const optionalParams = {
        listingTypes: params.listingTypes || null,
        propertyTypes: params.propertyTypes || null,
        bedrooms: params.bedrooms || null,
        pets: params.pets || null,
        laundry: params.laundry || null,
        amenities: params.amenities || null,
        orderBy: params.orderBy || null,
        deactivatedDays: params.deactivatedDays || null,
        distanceInMiles: params.distanceInMiles || null,
      };

      const marketUpdateParams: MarketUpdate = Object.assign(requiredParams, optionalParams);

      if (__DEV__) {
        return;
      }

      await dispatch(api.marketing.createMarketUpdate(marketUpdateParams));

      return true;
    } catch (error) {
      // @ts-ignore
      const shouldLogAction = !error.data || !error.data.action;
      augmentError(error, {
        ...(shouldLogAction && {
          action: 'Error in MarketingActions#createMarketUpdate',
        }),
        marketUpdateParams: params,
      });

      throw error;
    }
  };
};

export const updateSubscription = (updateSubscriptionData: Subscription) => {
  const { email, marketUpdateId, enabled } = updateSubscriptionData;
  // @ts-ignore
  return async (dispatch) => {
    const updateSubscriptionParams = { email, marketUpdateId, enabled };
    const { data, errors } = await dispatch(api.marketing.updateSubscription(updateSubscriptionParams));
    if (errors.length > 0) {
      const error = errors[0];
      augmentError(error, {
        action: 'Error in MarketingActions#updateSubscription',
        updateSubscriptionParams: updateSubscriptionData,
      });
      throw error;
    }
    return data;
  };
};

export const unsubscribeAll = (unsubscribeParams: UnsubscribeParams) => {
  // @ts-ignore
  return async (dispatch) => {
    const { email, cancelHash } = unsubscribeParams;
    if (!email || !cancelHash) {
      dispatch({
        type: constants.SET_UNSUBSCRIBE_ALL_SUCCESS,
        payload: false,
      });
      throw new Error(`Invalid email ${email} or cancelHash ${cancelHash}`);
    }
    const { data, errors } = await dispatch(api.marketing.unsubscribeAll(unsubscribeParams));
    if (errors.length > 0) {
      const error = errors[0];
      augmentError(error, {
        action: 'Error in MarketingActions#unsubscribeAll',
        unsubscribeParams,
      });
      dispatch({
        type: constants.SET_UNSUBSCRIBE_ALL_SUCCESS,
        payload: false,
      });
      throw error;
    }
    dispatch({
      type: constants.SET_UNSUBSCRIBE_ALL_SUCCESS,
      payload: true,
    });
    return data;
  };
};
